export enum ChainStage {
    MAINNET,
    TESTNET,
    TESTNET_SANDBOX,
  }